import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Box, IconButton, Typography, Button } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";


// const FullLineDashed = ({ label, value , sx = {} }) => (
//   <Box sx={{ display: "flex", mb: 1, alignItems: "center", flexWrap: "wrap" , ...sx}}>
//     <Typography component="span" sx={{ mr: 1 }}>{label}</Typography>
//     <Box
//       sx={{
//         borderBottom: "2px dashed #000080",
//         flex: 1,
//         minHeight: "24px",
//         px: 1,
//         color: "#000080",
//         fontWeight: "bold",
//         display: "flex",
//         alignItems: "center"
//       }}
//     >
//       {value}
//     </Box>
//   </Box>
// );

const FullLineDashed = ({ label, value, onChange, sx = {} }) => (
  <Box
    sx={{
      display: "flex",
      mb: 1,
      alignItems: "center",
      flexWrap: "wrap",
      ...sx,
    }}
  >
    <Typography component="span" sx={{ mr: 1 }}>
      {label}
    </Typography>

    <Box
      sx={{
        borderBottom: "2px dashed #000080",
        flex: 1,
        minHeight: "24px",
        px: 1,
        color: "#000080",
        fontWeight: "bold",
        display: "flex",
        alignItems: "center",
      }}
    >
      {onChange ? (
        // ✅ Editable ONLY if onChange is passed
        <input
          type="text"
          value={value}
          onChange={onChange}
          style={{
            border: "none",
            outline: "none",
            background: "transparent",
            width: "100%",
            fontWeight: "bold",
            color: "#000080",
          }}
        />
      ) : (
        // ✅ Read-only for all other fields
        value
      )}
    </Box>
  </Box>
);



const Bonafide3 = () => {
  const navigate = useNavigate();
  const componentRef = useRef();
  
  const location = useLocation();
  const studentData = location.state?.studentData;
  console.log("student:",studentData);

  const { oId } = useAuth();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const [originalData, setOriginalData] = useState({});
  const [loading, setLoading] = useState(true);


  const [character, setCharacter] = useState("Satisfactory");

   const [classSection, setClassSection] = useState(
    studentData?.romanNumberClass && studentData?.sections
      ? `${studentData.romanNumberClass} - ${studentData.sections}`
      : ""
  );
  const today = new Date();
const formatted = 
  String(today.getDate()).padStart(2, '0') + '-' +
  String(today.getMonth() + 1).padStart(2, '0') + '-' +
  today.getFullYear();
  
  const [companyInfo, setCompanyInfo] = useState({
            schoolName: "",
            pincode: "",
            primaryContact: "",
            secondaryContact: "",
            boardAffiliation: "",
            schoolAddress: "",
            affiliationNumber: "",
            city: "",
            state: "",
            schoolEmailId: "",
            schoolLogo: "",
            schoolStamp: "",
          });
   const [tempInfo, setTempInfo] = useState({ ...companyInfo });
   const [orgloading, setOrgLoading] = useState(true); 
   const [joinedYear, setJoinedYear] = useState(studentData?.studentJoinedYear || "");

    
  console.log("originaldata:",originalData);
  

  const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    //organization details api 
          useEffect(() => {
            const fetchCompanyInfo = async () => {
              try {
                const response = await fetch(`${baseUrl}/api/v1/organisation/${oId}`);
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                
        
                const data = await response.json();
                setCompanyInfo({
                  schoolLogo: data.schoolLogo,
                  schoolStamp:data.schoolStamp,
                  schoolName: data.schoolName,
                  city: data.city,
                  state: data.state,
                  affiliationNumber: data.affiliationNumber,
                  schoolAddress: data.schoolAddress,
                  primaryContact: data.primaryContact,
                  boardAffiliation: data.boardAffiliation,
                  secondaryContact: data.secondaryContact,
                  pincode: data.pincode,
                  schoolEmailId: data.schoolEmailId,
                });
                setTempInfo(data);
        
                setOrgLoading(false); // Data fetched, stop loading
        
              } catch (error) {
                console.error("Error fetching company info:", error);
                setOrgLoading(false); // Stop loading even if there's an error
              }
            };
        
            fetchCompanyInfo();
          }, []);

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: 3,
        backgroundColor: "#f4f6f9",
        margin: "60px 1% 1%",
        padding: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      {/* Back Button */}
      <Box className="print-hide" sx={{ position: "absolute", top: 20, left: 20, display: "flex", alignItems: "center", gap: 1 }}>
        <IconButton onClick={() => navigate(-1)} color="primary">
          <KeyboardBackspaceIcon />
        </IconButton>
        <Typography variant="h4" fontWeight="bold">
          Bonafide Certificate
        </Typography>
      </Box>

      {/* Print Button */}
      <Box className="print-hide" sx={{ position: "absolute", top: 20, right: 20 }}>
        <button
          onClick={handlePrint}
          style={{
            padding: "8px 16px",
            borderRadius: "8px",
            color: "#fff",
            cursor: "pointer",
            background: "linear-gradient(90deg, #3C3972, #3C3972)",
            border: "none",
            fontWeight: "bold",
            fontSize: "14px",
            boxShadow: "0 5px 10px rgba(30, 144, 255, 0.3)",
          }}
        >
          Print Bonafide
        </button>
      </Box>
<Box
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  }}
>
  {/* ✅ NOTE ABOVE CERTIFICATE */}
  <Box
  className="print-hide"
  sx={{
    mb: 2,
    p: 2,
    borderLeft: "5px solid #ff9800",
    backgroundColor: "#fff4e5",
    borderRadius: 1,
    width: "100%",
    maxWidth: "260mm",
    display: "flex",
    alignItems: "flex-start",
    gap: 1.2,
  }}
>
  <WarningAmberIcon sx={{ color: "#ff9800", mt: "2px" }} />

  <Typography
    variant="body2"
    sx={{
      color: "#5d4636",
      fontSize: "0.9rem",
      lineHeight: 1.4,
      fontWeight: 500,
    }}
  >
    1. Only the <strong>“During the year(s)”</strong>, <strong>“Class & Section”</strong>, and <strong>“Character”</strong> fields in the certificate below are <strong>editable</strong>.
    All other student details <strong>cannot be modified</strong>.
    <br /><br />

  2. Please verify the entered details carefully before printing, as the updated values
  will appear directly on the certificate.
  </Typography>
</Box>


  
      {/* Certificate */}
      <Box
        ref={componentRef}
        sx={{
          width: "215mm",
          padding: 1,
          border: "2px solid #000080",
          backgroundColor: "#f4f6f9",
        }}
      >
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#fff",
            padding: "10px 20px 20px 20px" ,
            border: "2px dotted #000080",
            color: "#000080",
            fontFamily: "Arial",
            position: "relative",
            boxSizing: "border-box",
          }}
        >
          {/* Header */}
         <Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 2,
  }}
>
  {/* Left: Logo */}
  <Box sx={{ width: 100, height: 100 }}>
            <img
              src={`data:image/jpeg;base64,${companyInfo.schoolLogo}`}
              alt="Logo"
              style={{
                width: "100px",         // Set a single value
                height: "100px",        // Match the width exactly
                borderRadius: "50%",    // Ensures circle
                objectFit: "cover",     // Ensures image fills without distortion
              }}
            />
  </Box>

  {/* Center: School Details */}
  <Box sx={{ flexGrow: 1, textAlign: "center", ml: -12 }}>
    <Typography
  variant="h4"
  sx={{ fontWeight: "bold", color: "#000080", lineHeight: 1.2 }}
>
  {companyInfo.schoolName}
  
</Typography>


    {/* <Typography
      variant="subtitle2"
      sx={{ fontStyle: "italic", fontSize: "1rem", color: "#000080" }}
    >
      A Bridge for IIT Oriented &amp; Medicine
    </Typography> */}

    <Typography
      variant="body2"
      sx={{ fontSize: "0.9rem", mt: 0.5, color: "#000080" }}
    >
      {companyInfo.schoolAddress} - {companyInfo.pincode}
    </Typography>

    <Typography
      variant="body2"
      sx={{ fontWeight: "bold",fontSize: "0.9rem", color: "#000080" }}
    >
      Phone: {companyInfo.primaryContact} | Email: {companyInfo.schoolEmailId}
    </Typography>

    <Typography
      variant="h6"
      sx={{
        textDecoration: "underline",
        fontWeight: "bold",
        mt: 1,
        fontSize: "1.0rem",
        color: "#000080",
      }}
    >
      Bonafide and Conduct Certificate
    </Typography>
  </Box>
</Box>


          {/* Admission Info */}
          <Box sx={{ mb: 2, display: "flex", justifyContent: "space-between" }}>
  <Typography variant="body1" fontStyle="italic">
    Admission No: <strong>{studentData?.customAdmissionNumber}</strong>
  </Typography>
  <Typography variant="body1" fontStyle="italic">
    Date: <strong>{formatted}</strong>
  </Typography>
</Box>

{/* <FullLineDashed
  label="This is to certify that Mr./Ms. "
  value={`${studentData?.firstName?.toUpperCase()} ${studentData?.lastName?.toUpperCase()}`}
  sx={{ ml: 10 }}
/>

<FullLineDashed
  label="Son / Daughter of Mr./Ms."
  value={`${studentData?.fathersFirstName?.toUpperCase()} ${studentData?.fathersLastName?.toUpperCase()}`}
/> */}
<FullLineDashed
  label="This is to certify that Mr./Ms. "
  value={
    studentData?.firstName || studentData?.lastName
      ? `${studentData?.firstName?.toUpperCase() || ""} ${studentData?.lastName?.toUpperCase() || ""}`.trim()
      : "NA"
  }
  sx={{ ml: 10 }}
/>

<FullLineDashed
  label="Son / Daughter of Mr./Ms."
  value={
    studentData?.fathersFirstName || studentData?.fathersLastName
      ? `${studentData?.fathersFirstName?.toUpperCase() || ""} ${studentData?.fathersLastName?.toUpperCase() || ""}`.trim()
      : "NA"
  }
/>


{/* <FullLineDashed
  label="was / is a bonafide student of this school, student in Class from"
  value={`${studentData?.romanNumberClass} - ${studentData?.sections} `}
/> */}
<FullLineDashed
  label="was / is a bonafide student of this school, student in Class from"
  value={classSection}
  onChange={(e) => setClassSection(e.target.value)}
/>

{/* <FullLineDashed
  label="during the year (s) from"
  value={`${studentData?.studentJoinedYear}`}
/> */}

<FullLineDashed
  label="during the year (s) from"
  value={joinedYear}
  onChange={(e) => setJoinedYear(e.target.value)}
/>


<FullLineDashed
  label="His / Her date of birth is as per the records"
  value={`${studentData?.dob}`}
/>

{/* <FullLineDashed
  label="His / Her character is was found"
  value="Satisfactory"
/> */}

<FullLineDashed
  label="His / Her character was found"
  value={character}
  onChange={(e) => setCharacter(e.target.value)}
/>



          <Typography align="right" sx={{ fontWeight: "bold", mt: 6 }}>
            Head of the School
          </Typography>
        </Box>
      </Box>
</Box>

    </Card>
  );
};

export default Bonafide3;